import React, {useEffect, useState} from "react";
import {Button, Checkbox, Divider} from 'antd';
import {projectStatusDisplayMap} from "../ProjectStatusMap";
import { Col, Grid, Row } from 'react-flexbox-grid';
import {mergeStationProjects, reRunMergeProcess} from "../../api/MergeUnMerge";
import SpinnerNew from "../Spinner/SpinnerNew";
import Card from "antd/es/card";
import {getProject} from "../../api";
import {getToolTipFormatedList, getToolTipFormatedStrB} from "../Utils/String";
import {Form} from "react-bootstrap";
import {commonMergeWarning, mergeInvalidProjectMsg, mergePreTaskWarningMsg, mergeTaskWarningMsg} from "./MergeMessages";


function MergeDialog({project, projectList, onClose, onMergeCancel, onMergeComplete}) {

    const [checkCount, setCheckCount] = useState(1);
    const [selectedList, setSelectedList] = useState([project.id]);
    const [selectedProjList, setSelectedProjList] = useState(projectList);
    const [mergeStarted, setMergeStarted] = useState(false);
    const [mergeProcess, setMergeProcess] = useState(null);
    const [yesBtnText, setYesBtnText] = useState('Yes, Merge');
    const [noBtnText, setNoBtnText] = useState('No, Keep Separate');
    const [mergeMessage, setMergeMessage] = useState(<>There are multiple projects at this Station.
        Which Projects would you like to Merge?</>);
    const [mergeFailed, setMergeFailed] = useState(false);
    const [pcContractorSelected, setPCContractorSelected] = useState(project.pcContractorSelected===1);
    const [pcContractorList, setPCContractorList] = useState([]);
    const [pcContractor, setPCContractor] = useState('NULL');

    useEffect(() => {
        if(mergeProcess && (mergeProcess.validation === 'REV_WARNING' || mergeProcess.preFormTaskCompleteWarning===false || mergeProcess.taskMergeWarning===false))
            return;
        let pcList1 = selectedProjList.filter(p=>(selectedList.includes(p.id) && p.pcContractor!==null && p.pcContractor!=='' && p.invalid===false)).map((p)=>{
            return p.pcContractor;
        });
        let pcList = pcList1.filter((value, index, self) => self.indexOf(value) === index);
        //console.log('selectedProjList',selectedProjList);
        //console.log('pcContractor',pcContractor);
        //console.log('pcList',pcList1);
        //console.log('pcList',pcList);
        let cnt = pcList.length;
        setPCContractorSelected(cnt>0);
        if(cnt === 1)
            setPCContractor(pcList[0]);
        else
            setPCContractor('NULL');
        setPCContractorList(pcList);
    },[selectedProjList]);

    function onCheckBoxClick(e, id)
    {
        let val = checkCount;
        if (e.target.checked === true)
        {
            val = val + 1;
            setCheckCount(val);
            selectedList.push(id);
        }
        else
        {
            const index = selectedList.indexOf(id);
            if (index > -1) {
                selectedList.splice(index, 1);
            }
            val = val - 1;
            setCheckCount(val);
        }
        // distinct pc contractor list on change
        let pcList = selectedProjList.filter(p=>(selectedList.includes(p.id) && p.pcContractor!==null && p.pcContractor!=='' && p.invalid===false)).map(p=>p.pcContractor);
        //console.log('pcList',pcList);
        pcList = pcList.filter((value, index, self) => self.indexOf(value) === index);
        let cnt = pcList.length;
        setPCContractorSelected(cnt>0);
        if(cnt === 1)
            setPCContractor(pcList[0]);
        else
            setPCContractor('NULL');
        setPCContractorList(pcList);
    }

    function handlePCChange(e){
        const selection = e.currentTarget.value;
        setPCContractor(selection);
    }

    async function handleMergeResponse(response) {
        if(response && response.data)
        {
            setMergeProcess(response.data);
        }
        if(response && response.data && response.data.status === 'FAILED')
        {
            setMergeFailed(true);
            let msg = <>Merge Process Failed.<br/>{response.data.processMsg}</>;
            setMergeMessage(<span style={{color:'red'}}>{msg}</span>);
            setNoBtnText('Cancel Merge');
        }
        else if(response && response.data && response.data.status === 'COMPLETED' && response.data.mergedProjectId)
        {
            setMergeMessage(<span style={{color:'blue'}}>Merge Process completed successfully.</span>);
            setNoBtnText('Close');
        }
        else if(response && response.data && response.data.status === 'COMPLETED_R' && response.data.mergedProjectId)
        {
            setMergeMessage(<span style={{color:'blue'}}>Merge Process completed successfully.<br/>
                The final merged project will have a Checklist Release Date that is EARLIER than one of the unmerged projects. Please coordinate with the CCA.</span>);
            setNoBtnText('Close');
        }
        else if(response && response.data && response.data.validation === 'INVALID_PRE')
        {
            let validResponseList = response.data.detailRecords.filter(t=>t.validationFlag==='Y').map(t=> {return t.projectId;});
            let inValidResponseList = response.data.detailRecords.filter(t=>t.validationFlag==='N').map(t=> {return t.projectId;});
            let validList = projectList.filter(t=>validResponseList.includes(t.id)).map(p=> {return { ...p, 'invalid': false, 'selected':true};});
            let inValidList = projectList.filter(t=>inValidResponseList.includes(t.id)).map(p=> {return { ...p, 'invalid': true, 'selected':true};});
            //console.log('response', response);
            let totalList = validList.concat(inValidList);
            //console.log('totalList', totalList);
            setSelectedProjList([]);
            setSelectedProjList(totalList);
            setSelectedList(validResponseList);
            setCheckCount(validResponseList.length);
            if(validList.length < 2)
            {
                setMergeMessage(<div>{mergeInvalidProjectMsg}<div style={{color:'red'}}>There are not enough valid projects to Merge.</div></div>);
            }
            else {
                setMergeMessage(<div>{mergeInvalidProjectMsg}<div style={{color:'red'}}>There is at least one project which did not meet the merge validation. Please choose which of the remaining
                    projects you would like to Merge?</div></div>);
            }
            setNoBtnText('Cancel Merge');
        }
        else if(response && response.data && (response.data.preFormTaskCompleteWarning===false || response.data.validation === 'REV_WARNING'
            || response.data.taskMergeWarning===false))
        {
            setMergeMessage(<div>{commonMergeWarning}
                { (response.data.taskMergeWarning===false || response.data.validation === 'REV_WARNING') && mergeTaskWarningMsg}
                {response.data.preFormTaskCompleteWarning===false && mergePreTaskWarningMsg}
                <div>Do you want to proceed with the Merge?</div></div>);
            setNoBtnText('Cancel Merge');
            let validList = projectList.filter(t=>selectedList.includes(t.id)).map(p=> {return { ...p, 'invalid': false, 'selected':true};});
            setPCContractor(response.data.pcContractor);
            //console.log('mergeProcess,,,,,,,',response)
            setSelectedProjList(validList);
        }
        else
        {
            setMergeFailed(true);
            setMergeMessage(<span style={{color:'red'}}>Unknown Error, Merge Process Failed... Please contact support.</span>)
            setNoBtnText('Cancel Merge');
        }
    }
    function getStationName(p)
    {
        if(p.projectStatus === 'A')
            return      (<div style={{color: '#7eb941'}}>{p.stationName}</div>);
        else if(p.projectStatus === 'R')
            return      (<div style={{color: '#c1370d'}}>{p.stationName}</div>);
        else if(p.projectStatus === 'D')
            return      (<div style={{color: '#0077b5'}}>{p.stationName}</div>);
        else if(p.projectStatus === 'U')
            return      (<div style={{color: '#34b3e4'}}>{p.stationName}</div>);
        else
            return      (<div>{p.stationName}</div>);
    }

    return (
        <Card
            style={{width:'600px'}}
            title={"Merge Projects?"}
            actions={[<Button
                id={'yesMergeBtn'}
                type={"link"}
                style={{height: 'auto'}}
                disabled={checkCount < 2 || mergeStarted || mergeFailed || (pcContractorSelected && (pcContractor===null || pcContractor==='NULL'))
                || (mergeProcess && (mergeProcess.status==='COMPLETED' || mergeProcess.status==='COMPLETED_R'))}
                onClick={async () => {
                    // call merge
                    //console.log('projectList.....', projectList);
                    let response = null;
                    setMergeStarted(true);
                    setMergeMessage('Merge Process in Progress...');
                    if(mergeProcess === null)
                    {
                        let mergeRequest = {'runId': null, 'station': project.stationName, 'selectedProjectId': project.id,
                            'selectedList': selectedList, pcContractor: pcContractor==='NULL' ? null : pcContractor };
                        response = await mergeStationProjects(project.stationName, mergeRequest);
                        //console.log('response,,,,,,,,,,,,,',response);

                    }
                    else if(mergeProcess.status !== 'FAILED' && mergeProcess.validation === 'INVALID_PRE')
                    {
                        // rerun with new/old selected list
                        let mergeRequest = {'runId': mergeProcess.runId, 'station': project.stationName, 'selectedProjectId': project.id,
                            'selectedList': selectedList, pcContractor: pcContractor==='NULL' ? null : pcContractor };
                        response = await mergeStationProjects(project.stationName, mergeRequest);

                    }
                    else if(mergeProcess.status !== 'FAILED' && (mergeProcess.validation === 'REV_WARNING' || mergeProcess.preFormTaskCompleteWarning===false
                        || mergeProcess.taskMergeWarning===false))
                    {
                        response = await reRunMergeProcess(project.stationName, mergeProcess.runId);
                    }
                    setMergeStarted(false);
                    await handleMergeResponse(response);
                }}
            >
                <b>{yesBtnText}</b>
            </Button>,
                <Button
                    type={"link"}
                    style={{height: 'auto'}}
                    disabled={mergeStarted}
                    onClick={async () => {
                        if(mergeProcess !== null && mergeProcess.status !== 'COMPLETED' && mergeProcess.status !== 'COMPLETED_R' && mergeProcess.status !== 'FAILED')
                        {
                            await onMergeCancel(mergeProcess.runId);
                        }
                        if(mergeProcess !== null && (mergeProcess.status === 'COMPLETED' || mergeProcess.status === 'COMPLETED_R'))
                        {
                            let mergeP = await getProject(mergeProcess.mergedProjectId);
                            onMergeComplete(mergeP);
                        }
                        onClose();
                    }}
                >
                    <b>{noBtnText}</b>
                </Button>]}
            headStyle={{fontWeight: 700, fontSize: "20px"}}
        >
            <SpinnerNew display={mergeStarted}/>
            <div>{mergeMessage}</div>
            <Divider/>
            <Grid  style={{maxHeight:'500px', overflowY:'scroll'}}>
                {selectedProjList.map((p,index) => (
                    <div>
                        <Row>
                            <Col lg={1} md={1} xs={1}>
                                {((p.id === project.id) || (mergeProcess && (mergeProcess.validation==='REV_WARNING' || mergeProcess.preFormTaskCompleteWarning===false
                                    || mergeProcess.taskMergeWarning===false))) ?
                                    <Checkbox id={'checkbox'+p.bpid} checked={true} disabled={true}/>
                                    :
                                    (
                                        (p.invalid === true) ?
                                            <Checkbox id={'checkbox'+p.bpid} disabled={true} checked={false}/> :
                                            <Checkbox id={'checkbox'+p.bpid} defaultChecked={p.selected}
                                                      disabled={mergeStarted || (mergeProcess &&
                                                          (mergeProcess.validation==='REV_WARNING' || mergeProcess.status==='COMPLETED'
                                                              || mergeProcess.status==='COMPLETED_R' || mergeProcess.status==='FAILED'
                                                              || mergeProcess.preFormTaskCompleteWarning===false
                                                              || mergeProcess.taskMergeWarning===false))}
                                                      onClick={(e) => onCheckBoxClick(e, p.id)}/>
                                    )
                                }
                            </Col>

                            <Col lg={11} md={11} xs={11}>
                                {(p.id === project.id) ?
                                    <b>{getStationName(p)}</b>
                                    :
                                    ((p.invalid && p.invalid === true) ?
                                        <div style={{color: 'red'}}><b>{p.stationName}{' - INVALID'}</b></div> :
                                        <div><b>{getStationName(p)}</b></div>)
                                }
                                <div><b>Project Description:</b></div>
                                <div>{p.linkProjectCount === 0 ? p.projectDescription : getToolTipFormatedList(p.allProjectDescs)}</div>
                                <br/>
                                {!(mergeProcess && (mergeProcess.validation === 'REV_WARNING' || mergeProcess.validation === 'INVALID_PRE'
                                    || mergeProcess.preFormTaskCompleteWarning===false || mergeProcess.taskMergeWarning===false)) &&
                                <>
                                    <div><b>Construction Start Date:</b> {p.constructionStartDate}</div>
                                    {p.projectStatus!=='U' && <div><b>Checklist Release Date:</b> {p.commisioningStartDate}</div>}
                                    <div><b>In-Service Date:</b> {p.inServiceDate}</div>
                                    {p.projectStatus!=='U' && <div><b>Expected Close Date:</b> {p.expectedCloseDate}</div>}
                                    <br/>
                                    <div>{getToolTipFormatedStrB('WO',p.workOrder)}</div>
                                    <div>{getToolTipFormatedStrB('BPID',p.bpid)}</div>
                                    <div>{getToolTipFormatedStrB('MPID',p.mpid)}</div>
                                </>
                                }
                                <div><b>Status: </b>{projectStatusDisplayMap[p.projectStatus]}</div>
                                {!(mergeProcess && (mergeProcess.validation === 'REV_WARNING' || mergeProcess.preFormTaskCompleteWarning===false
                                    || mergeProcess.taskMergeWarning===false)) &&
                                <>
                                    <br/>
                                    {(p.projectStatus==='R' || p.projectStatus==='A') && <div><b>Pre Job:</b> {p.preJobPercent ? (p.preJobPercent+'%') : '0%'}</div>}
                                    {   (p.showSecurityTasks === 1) &&
                                    (
                                        (mergeProcess && mergeProcess.validation==='INVALID_PRE' && (p.invalid === true || p.cipSecurityPercent !== 100)) ?
                                            <div style={{color: 'red'}}><b>CIP:</b> Yes, {p.cipSecurityPercent ? (p.cipSecurityPercent+'%') : '0%'}</div>
                                            :
                                            <div><b>CIP:</b> Yes, {p.cipSecurityPercent ? (p.cipSecurityPercent + '%') : '0%'}</div>
                                    )
                                    }
                                </>
                                }
                                { (p.projectStatus === 'R' || p.projectStatus === 'A') &&
                                (
                                    (mergeProcess && mergeProcess.validation==='INVALID_PRE' && p.energizedCnt > 0) ?
                                        <div style={{color: 'red'}}><b>Energized Pre-E Forms:</b> Yes</div>
                                        : <div><b>Energized Pre-E Forms:</b> {p.energizedCnt > 0 ? 'Yes' : 'No'}</div>
                                )
                                }
                                {(mergeProcess && (mergeProcess.validation==='REV_WARNING' || mergeProcess.preFormTaskCompleteWarning===false
                                    || mergeProcess.taskMergeWarning===false)) &&
                                <>
                                    {(p.projectStatus==='R' || p.projectStatus==='A') &&
                                    (  (mergeProcess.preFormTaskCompleteWarning===false && p.energizedReadyCnt>0) ?
                                            <div style={{color: 'red'}}><b>Ready Pre-E Forms:</b> {p.energizedReadyCnt>0 ? 'Yes' : 'No'}</div>
                                            : <div><b>Ready Pre-E Forms:</b> {p.energizedReadyCnt>0 ? 'Yes' : 'No'}</div>
                                    )
                                    }

                                    {
                                        (mergeProcess.preTaskRevNo===p.preTaskRevNo) ?
                                            <div><span style={{color:'black', background:'yellow'}}><b>Pre Job:</b> Revision {p.preTaskRevNo}, {p.preJobPercent ? (p.preJobPercent+'%') : '0%'}</span></div>
                                            : <div><b>Pre Job:</b> Revision {p.preTaskRevNo}, {p.preJobPercent ? (p.preJobPercent+'%') : '0%'}</div>
                                    }

                                    {
                                        (mergeProcess.postTaskRevNo===p.postTaskRevNo) ?
                                            <div><span style={{color:'black', background:'yellow'}}><b>Post Job:</b> Revision {p.postTaskRevNo}, {p.postJobPercent ? (p.postJobPercent+'%') : '0%'}</span></div>
                                            : <div><b>Post Job:</b> Revision {p.postTaskRevNo}, {p.postJobPercent ? (p.postJobPercent+'%') : '0%'}</div>
                                    }

                                    { p.showRemovalTasks===1 &&
                                    ((mergeProcess.removalTaskRevNo===p.removalTaskRevNo) ?
                                            <div><span style={{color:'black', background:'yellow'}}><b>Removals:</b> Revision {p.removalTaskRevNo}, {p.removalJobPercent ? (p.removalJobPercent+'%') : '0%'}</span></div>
                                            : <div><b>Removals:</b> Revision {p.removalTaskRevNo}, {p.removalJobPercent ? (p.removalJobPercent+'%') : '0%'}</div>
                                    )
                                    }

                                    { p.showSecurityTasks===1 &&
                                    ((mergeProcess.securityTaskRevNo===p.securityTaskRevNo) ?
                                            <div><span style={{color:'black', background:'yellow'}}><b>CIP:</b> Revision {p.securityTaskRevNo}, {p.cipSecurityPercent ? (p.cipSecurityPercent+'%') : '0%'}</span></div>
                                            : <div><b>CIP:</b> Revision {p.securityTaskRevNo}, {p.cipSecurityPercent ? (p.cipSecurityPercent+'%') : '0%'}</div>
                                    )
                                    }

                                    {mergeProcess.preFormTaskCompleteWarning===false && p.energizedReadyCnt>0 &&
                                    <div style={{color: 'red'}}>** Any Pre-E Forms that are ‘Ready for Energization’ may be reverted to ‘In Progress’
                                        based on the final % Complete of the Task Versions being kept. **</div>
                                    }
                                </>
                                }
                            </Col>
                        </Row>
                        {index < (selectedProjList.length-1) ? <hr/> : ''}
                    </div>
                ))}
            </Grid>
            {((pcContractor && pcContractor!=='NULL') || pcContractorList.length > 0) &&
            <div>
                <hr/>
                <Row>
                    <Col lg={4} md={4} xs={4}>
                        <b>Select P&C Contractor:</b>
                    </Col>
                    <Col lg={8} md={8} xs={8}>
                        {
                            pcContractorList.length > 1 ?
                                <Form.Control as='select' id='pc_contractor-selector' value={pcContractor} onChange={handlePCChange}  style={{color:'blue'}}
                                              disabled={mergeStarted || mergeFailed ||
                                              (mergeProcess && (mergeProcess.validation==='REV_WARNING' || mergeProcess.status==='COMPLETED'
                                                  || mergeProcess.status==='COMPLETED_R' || mergeProcess.status==='FAILED'
                                                  || mergeProcess.preFormTaskCompleteWarning===false || mergeProcess.taskMergeWarning===false))}>
                                    <option value={'NULL'}>{'Select P&C Contractor'}</option>
                                    {
                                        pcContractorList.map((c) =>
                                            <option value={c}>{c}</option>
                                        )
                                    }
                                </Form.Control>
                                :
                                <div style={{color:'blue'}}>{pcContractor}</div>
                        }
                    </Col>
                </Row>
            </div>
            }
        </Card>
    )
}

export default MergeDialog;
